import { Outlet } from 'react-router-dom'
import { Sidebar } from '@/components/layout/Sidebar'
import { TopBar } from '@/components/layout/TopBar'
import { BreadcrumbProvider } from '@/contexts/BreadcrumbContext'
import { TopBarActionsProvider } from '@/contexts/TopBarActionsContext'

export default function Layout() {
  return (
    <BreadcrumbProvider>
      <TopBarActionsProvider>
        <div className='flex min-h-screen bg-background'>
          <Sidebar />

          <div className='flex min-w-0 flex-1 flex-col'>
            <TopBar />

            <main className='flex flex-1 flex-col bg-[#F4F5F8] p-6'>
              <Outlet />
            </main>
          </div>
        </div>
      </TopBarActionsProvider>
    </BreadcrumbProvider>
  )
}
